import React, { forwardRef } from "react";
import { default as MUITooltip } from "@mui/material/Tooltip";
import styled from "styled-components";

const StyledMUITooltip = styled(MUITooltip)``;

export const Tooltip = forwardRef(({ id, title, placement, children }, ref) => (
  <StyledMUITooltip id={id} title={title} placement={placement} ref={ref}>
    {children}
  </StyledMUITooltip>
));
